import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BaseApiService } from '../_base-http/base-api.service';
import { MasterComponent } from '../_layout/master/master.component';
import { CategoryService } from './category.service';
import { NavigationService } from './navigation.service';
import { RouteCustomService } from './route-custom.service';
import { StateService } from './state.service';

@Injectable({
  providedIn: 'root',
})
export class SiteLanguageService extends BaseApiService {
  currentLang = 'vi';
  constructor(
    private _http: HttpClient,
    private _router: Router,
    private _stateService: StateService,
    private _navService: NavigationService,
    private _cateService: CategoryService,
    private _routeCustom: RouteCustomService,
  ) {
    super(_http, _stateService);
    this._stateService.currentLanguage$.subscribe((l: string) => {
      this.currentLang = l;
    });
  }

  async getTree() {
    return await this._navService.getNavigationForHeader();
  }

  async getCategories() {
    return await this._cateService.getAll();
  }

  setDefaultMasterRouter() {
    this._router.config = [
      {
        path: '',
        component: MasterComponent,
        children: [],
      },
    ];
  }

  async createTree() {
    const tree = await this.getTree();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const categories = await this.getCategories();
    this.setDefaultMasterRouter();
    this._routeCustom.createTree(this._navService, this._cateService, this.currentLang, this._router, tree);
  }
}
